import React from "react";

import {deliveryStatusClassName, deliveryStatusIconClassName} from "../../helpers/deliveryStatusMarkup";

export function DeliveryStatus({status}) {
    if (!status) {
        return <span>-</span>;
    }

    const icon = deliveryStatusIconClassName(status.kind);

    return (
      <span className={deliveryStatusClassName(status.kind)}>
            {icon && <><i className={icon}></i> </>}{status.label}
        </span>
    );
}
